var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.2083C10.5278 10.2083 10.9722 10.0278 11.3333 9.66665C11.6944 9.30554 11.875 8.86109 11.875 8.33331C11.875 7.80554 11.6944 7.36109 11.3333 6.99998C10.9722 6.63887 10.5278 6.45831 10 6.45831C9.47222 6.45831 9.02778 6.63887 8.66667 6.99998C8.30556 7.36109 8.125 7.80554 8.125 8.33331C8.125 8.86109 8.30556 9.30554 8.66667 9.66665C9.02778 10.0278 9.47222 10.2083 10 10.2083ZM10 19.0416C7.54167 17 5.69792 15.1458 4.46875 13.4791C3.23958 11.8125 2.625 10.125 2.625 8.41665C2.625 6.14276 3.36632 4.33123 4.84896 2.98206C6.33174 1.6329 8.04875 0.958313 10 0.958313C11.9513 0.958313 13.6683 1.6329 15.151 2.98206C16.6337 4.33123 17.375 6.14276 17.375 8.41665C17.375 10.125 16.7604 11.8125 15.5312 13.4791C14.3021 15.1458 12.4583 17 10 19.0416Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.12ab3d6f90a0579918a4e6973c8b009e.svg";
export { ForwardRef as ReactComponent };